import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaTimes } from "react-icons/fa"; 
import axiosInstance from "config/axiosInstance";
import FetchFailed from 'reusable/FetchFailed';
import { useLatestRequest } from 'reusable/useLatestRequest';
import { useTranslation } from 'react-i18next';


interface Device {
    id: number;
    name: string;
    type: string;
    status: string;
    // Add other relevant fields here
  }
interface AssignedDevicePopupProps {
  onClose: () => void; 
}

const AssignedDevicePopup: React.FC<AssignedDevicePopupProps> = ({ onClose }) => {
  const { t } = useTranslation('common');
    const { id } = useParams<{ id: string }>();
    const beginRequest = useLatestRequest();
    const [loading, setLoading] = useState(true);
    const [loadedId, setLoadedId] = useState<string>();
    const [fetchError, setFetchError] = useState<unknown>(null);
    const [driverName, setDriverName] = useState('Unknown');
    const [assignedDevice, setAssignedDevice] = useState<Device[]>([]);

    const fetchData = useCallback(async () => {
        const isCurrent = beginRequest();
        setLoading(true); setFetchError(null);
        try {
          const Driverapi = `/v1/devices/?user=${id}`;
          const response = await axiosInstance.get(Driverapi);
          if (!isCurrent()) return;
          setDriverName(response.data.results[0]?.user_info?.name ?? 'Unknown');
          setAssignedDevice(response.data.results);
          
        } catch (error) {
          if (!isCurrent()) return;
          setFetchError(error);
        } finally {
          if (isCurrent()) { setLoading(false); setLoadedId(id); }
        }
      }, [id, beginRequest]);
    
      useEffect(() => {
        if (id) {
          fetchData();
        }
      }, [id, fetchData]);
      
  return (
    <section className="flex flex-col w-full bg-white rounded-md">
      <div className="flex flex-row items-center justify-between mb-4 border-b">
        <h4 className="text-title p-4">{t('ui.assigned-devices', { ns: 'driver' })}</h4>
        {/* 2026-10-24 axe（button-name）。ほかのダイアログの × と同じ「閉じる」。 */}
        <button type="button" onClick={onClose} aria-label={t('ui.close')} className="text-gray-600 hover:text-gray-800 p-4">
          <FaTimes className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      {loading || loadedId !== id ? <p role="status">{t('ui.loading')}</p> : fetchError ?
        <FetchFailed error={fetchError} onRetry={fetchData} /> : (
      <div className="flex flex-row justify-between p-4">
        <div className="flex-1">
            <label className="text-gray-600">DRIVER NAME</label>
            <h6 className="font-semibold">{driverName}</h6>
        </div>
        <div className="flex-1">
            <label className="text-gray-600">ASSIGNED DEVICES</label>
            {assignedDevice.length > 0 ? (
            <ul className="space-y-2">
              {assignedDevice.map((device) => (
                <li key={device.id} className="flex justify-between items-center p-2 rounded-md">
                  <span className="font-medium">{device.id}</span>
                  <span className="text-gray-500">{device.name}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">{t('ui.no-devices', { ns: 'driver' })}</p>
          )}
        </div>
      </div>
      )}
    </section>
  );
}

export default AssignedDevicePopup;